import { render, staticRenderFns } from "./rules-layout.vue?vue&type=template&id=f2323616&"
import script from "./rules-layout.vue?vue&type=script&lang=js&"
export * from "./rules-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports